export default __webpack_public_path__ + "static/media/IMG_2176.94d47f66.JPG";